import PlusIcon from '@/assets/icons/plus.svg?react';
import Button from '@/components/ui/button/button.component';
import { cn } from '@/lib/utils';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  context: 'products' | 'templates' | 'product-groups';
  productsTitle: React.ReactNode;
  templatesTitle: React.ReactNode;
  addButtonTitle: React.ReactNode;
  addButtonAction: () => void;
  handleNavigation?: () => void;
}

export const NavigationBar = ({
  context,
  productsTitle,
  templatesTitle,
  addButtonTitle,
  addButtonAction: handleProductAction,
  handleNavigation: onNavClick,
}: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="flex flex-row justify-between items-center mb-6">
      <div className="flex flex-row gap-6">
        <Button
          variant="ghost"
          onClick={() => {
            if (onNavClick) onNavClick();
            if (!onNavClick) navigate('/products');
          }}
        >
          <h1
            data-testid="product-page-title"
            className={cn('text-primary-text', !location.pathname.includes('/products') && 'text-secondary-text')}
          >
            {productsTitle}
          </h1>
        </Button>
        <Button
          variant="ghost"
          onClick={() => {
            if (onNavClick) onNavClick();
            if (!onNavClick) navigate('/templates');
          }}
        >
          <h1
            data-testid="templates-page-title"
            className={cn('text-primary-text', !location.pathname.includes('/templates') && 'text-secondary-text')}
          >
            {templatesTitle}
          </h1>
        </Button>
      </div>

      <Button data-testid={`${context}-page-add-${context}-button`} onClick={handleProductAction} variant="default">
        <PlusIcon className="w-5 mr-2 text-primary" />
        {addButtonTitle}
      </Button>
    </div>
  );
};
